import React from "react";
import PropTypes from "prop-types";
import { ActionBar } from "../actionbar/ActionBarJS";
import EmptyResult from "./EmptyFieldList";
import RootTreeLayout from "./RootTreeLayout";
import TreeItemStore from "data/TreeItemStore";
import TreeItemActions from "data/TreeItemActions";
import Dispatcher from "Dispatcher";
import MappingStore from "data/MappingStore";
import TableStore from "data/TableStore";
import entityMetaStore from "data/meta/entityMetaStore";
import MapDialogActions from "data/MapDialogActions";
import BuildMappingTreeVisitor from "data/selectors/BuildMappingTreeVisitor";
import TableAccess from "data/util/TableAccess";
import OverStore from "data/OverStore";
import useFluxStore from "@armus/use-flux-store";

export class RecordSourceTreeGridLayout extends React.Component {

    render() {
        const {
            rootItem,
            sourceRecordType,
            targetRecordType,
            targetRecordLabel,
            isMagicRoot,
            onCancel,
            onSave,
            onIncludeMagicRootFields,
            onExcludeMagicRootFields,
            onExpandAll,
            onCollapseAll,
            isKeyExpanded,
            onChildCollapseOrExpand,
        } = this.props;
        let resultsTable, actionBar;
        if (rootItem) {
            resultsTable = (
                <div className="results-table">
                    <RootTreeLayout
                        targetRecordType={targetRecordType}
                        rootItem={rootItem}
                        isMagicRoot={isMagicRoot}
                        onIncludeMagicRootFields={onIncludeMagicRootFields}
                        onExcludeMagicRootFields={onExcludeMagicRootFields}
                        onExpandAll={onExpandAll}
                        onCollapseAll={onCollapseAll}
                        isKeyExpanded={isKeyExpanded}
                        onChildCollapseOrExpand={onChildCollapseOrExpand}
                    />
                </div>
            );

            actionBar = (
                <div className="row mapping-action-bar">
                    <ActionBar
                        onCancel={onCancel}
                        onSave={onSave}
                    />
                </div>
            );
        } else {
            actionBar = (
                <div className="row mapping-action-bar">
                    <EmptyResult />
                </div>
            );
        }

        return (
            <div className="mapping-content">
                <div className="row mapping-header">
                    <div className="col-md-12">
                        { sourceRecordType } <img alt="" src="images/mapping_arrow.svg"/> { targetRecordType } { targetRecordLabel }
                    </div>
                </div>
                {actionBar}
                {resultsTable}
            </div>
        );
    }
}

RecordSourceTreeGridLayout.propTypes = {
    rootItem: PropTypes.object.isRequired,
    sourceRecordType: PropTypes.string.isRequired,
    targetRecordType: PropTypes.string.isRequired,
    targetRecordLabel: PropTypes.string.isRequired,
    isMagicRoot: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onIncludeMagicRootFields: PropTypes.func.isRequired,
    onExcludeMagicRootFields: PropTypes.func.isRequired,
    onExpandAll: PropTypes.func.isRequired,
    onCollapseAll: PropTypes.func.isRequired,
    isKeyExpanded: PropTypes.func.isRequired,
    onChildCollapseOrExpand: PropTypes.func.isRequired,
};

export const FluxRecordSourceTreeGridLayout = props => {
    const {ctx, onImport, onCancel, isKeyExpanded} = props;
    const state = useFluxStore((prevState) => {
        if (OverStore.isModalShowing()) return prevState;
        if (!MappingStore.isReady()) return prevState;
        const mappingState = MappingStore.getState();
        const tree = new BuildMappingTreeVisitor(
            mappingState,
            new TableAccess(TableStore.getState()),
            new TableAccess(TableStore.getSnapshot()),
        )
            .execute()
            .getTree();
        const sourceKey = tree.source.entityKey;
        const targetKey = tree.target.entityKey;
        const treeItemState = TreeItemStore.getState(ctx);
        return {
            // the main goodies
            rootItem: {
                ...tree,
                depth: 0,
            },

            // chrome bits
            onSave: onImport,
            onCancel: onCancel,
            isMagicRoot: tree.isMagicRoot,
            sourceRecordType: entityMetaStore.getInfo(sourceKey).label,
            targetRecordLabel: tree.label,
            targetRecordType: entityMetaStore.getInfo(targetKey).label,

            // mapping event handlers
            onIncludeMagicRootFields: () => Dispatcher.dispatch({
                type: MapDialogActions.SET_MAGIC_ROOT_EXCLUSION,
                excluded: false,
            }),
            onExcludeMagicRootFields: () => Dispatcher.dispatch({
                type: MapDialogActions.SET_MAGIC_ROOT_EXCLUSION,
                excluded: true,
            }),

            // TreeGrid handlers
            isKeyExpanded: isKeyExpanded,
            expandedAll: treeItemState.expandAllNodes,
            onChildCollapseOrExpand: TreeItemActions.childCollapseOrExpand.bind(
                undefined,
                ctx,
            ),
            onCollapseAll: TreeItemActions.collapseAll.bind(undefined, ctx),
            onExpandAll: TreeItemActions.expandAll.bind(undefined, ctx),
        };
    }, [
        MappingStore,
        TreeItemStore,
        TableStore,
        OverStore,
    ], [ctx, onImport, onCancel, isKeyExpanded]);
    return state && state.rootItem
        ? <RecordSourceTreeGridLayout {...state} />
        : null; // render nothing
};

FluxRecordSourceTreeGridLayout.propTypes = {
    ctx: PropTypes.string.isRequired,
    onImport: PropTypes.func,
    onCancel: PropTypes.func,
    isKeyExpanded: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/lib/mapping/views/recordsourcetreegrid/RecordSourceTreeGridLayoutJS.js